/* tslint:disable */
/* eslint-disable */
/**
 * topi Seller API
 * # Localization  Strings returned can be localized when the _Accept-Language_ header is provided in the request. It should follow the [RFC-2616 convention](http://www.ietf.org/rfc/rfc2616.txt).
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddProductFromJSON, AddProductToJSON, } from './AddProduct';
/**
 * Check if a given object implements the ImportCatalogRequestBody interface.
 */
export function instanceOfImportCatalogRequestBody(value) {
    let isInstance = true;
    isInstance = isInstance && "products" in value;
    return isInstance;
}
export function ImportCatalogRequestBodyFromJSON(json) {
    return ImportCatalogRequestBodyFromJSONTyped(json, false);
}
export function ImportCatalogRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'products': (json['products'].map(AddProductFromJSON)),
    };
}
export function ImportCatalogRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'products': (value.products.map(AddProductToJSON)),
    };
}
